// Constants for account types
export const CHECKINGS_ACCOUNT_TYPE = 'checkings';
export const SAVINGS_ACCOUNT_TYPE = 'savings';
